angular.module('core').filter('upperSnakeCase', [
    function() {
        // convert input parts into upper snake case string
        // ['fish', 'hat'] -> 'FISH_HAT'
        // null -> 'NULL'
        // 'fish' -> 'FISH'
        // 3 -> '3'
        // [3, 'fish', 'cat'] -> 3_FISH_CAT
        return function(parts) {
            var partsArray;

            if (!_.isArray(parts)) {
                partsArray = [parts];
            } else {
                partsArray = parts;
            }

            return _.map(partsArray, function (part) {
                    return ('' + part).toUpperCase();
                })
                .join('_');
        };
    }
]);
